import * as GPhoneNumber from 'google-libphonenumber';
import { start } from 'repl';
import { ExpiryDate } from '../Types/Payments/PaymentDetails';
import Common from './Common';

// tslint:disable-next-line:max-line-length
let postcode = /^([A-Pa-pR-UWYZr-uwyz0-9][A-Ha-hK-Yk-y0-9][AEHMNPRTVXYaehmnprtvxy0-9]?[ABEHMNPRVWXYabehmnprvwxy0-9]? {0,2}[0-9][ABD-HJLN-UW-Zabd-hjln-uw-z]{2}? {0,3}|GIR 0AA)$/;
let emailaddr = /^([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/;
let accountnumber = /^[0-9]{6,8}$/;
let sortcode = /^[0-9]{6}$/;
let issuenumber = /^[0-9]{2}$/;
let securitycode = /^[0-9]{3}$/;
let phoneNumbrValidation = /^[\d+\s()]{1,20}$/;
// tslint:disable-next-line:max-line-length
let ibanNumber = /^(?:(?:IT|SM)\d{2}[A-Z]\d{22}|CY\d{2}[A-Z]\d{23}|NL\d{2}[A-Z]{4}\d{10}|LV\d{2}[A-Z]{4}\d{13}|(?:BG|BH|GB|IE)\d{2}[A-Z]{4}\d{14}|GI\d{2}[A-Z]{4}\d{15}|RO\d{2}[A-Z]{4}\d{16}|KW\d{2}[A-Z]{4}\d{22}|MT\d{2}[A-Z]{4}\d{23}|NO\d{13}|(?:DK|FI|GL|FO)\d{16}|MK\d{17}|(?:AT|EE|KZ|LU|XK)\d{18}|(?:BA|HR|LI|CH|CR)\d{19}|(?:GE|DE|LT|ME|RS)\d{20}|IL\d{21}|(?:AD|CZ|ES|MD|SA)\d{22}|PT\d{23}|(?:BE|IS)\d{24}|(?:FR|MR|MC)\d{25}|(?:AL|DO|LB|PL)\d{26}|(?:AZ|HU)\d{27}|(?:GR|MU)\d{28})$/;
// tslint:disable-next-line:max-line-length
let domain = /^(?!(https:\/\/|http:\/\/|www\.|mailto:|smtp:|ftp:\/\/|ftps:\/\/))(((([a-zA-Z0-9])|([a-zA-Z0-9][a-zA-Z0-9\-]{0,86}[a-zA-Z0-9]))\.(([a-zA-Z0-9])|([a-zA-Z0-9][a-zA-Z0-9\-]{0,73}[a-zA-Z0-9]))\.(([a-zA-Z0-9]{2,12}\.[a-zA-Z0-9]{2,12})|([a-zA-Z0-9]{2,25})))|((([a-zA-Z0-9])|([a-zA-Z0-9][a-zA-Z0-9\-]{0,162}[a-zA-Z0-9]))\.(([a-zA-Z0-9]{2,12}\.[a-zA-Z0-9]{2,12})|([a-zA-Z0-9]{2,25}))))$/;
// let blank = /^\s*$/;
// tslint:disable-next-line:max-line-length
let eircode = /^([AC-FHKNPRTV-Y]{1}[0-9]{2}|D6W)[ ]?[0-9AC-FHKNPRTV-Y]{4}$/;

class Validator {
  static isPhoneNumber(phoneNumber: string, isRegexValidation: boolean): boolean {
    const phoneUtil = GPhoneNumber.PhoneNumberUtil.getInstance();

    try {
      if (isRegexValidation) {
        return phoneNumbrValidation.test(phoneNumber);
      } else {
        const parsedNumber: GPhoneNumber.PhoneNumber = phoneUtil.parse(phoneNumber, 'GB');
        return phoneUtil.isValidNumber(parsedNumber);  
      }
    } catch (e) {
      return false;
    }
  }

  static isPostcode(pc: string): boolean {
    return postcode.test(pc);
  }

  static isSortcode(sort: string): boolean {
    return sortcode.test(sort);
  }

  static isIBANNumber(sort: string): boolean {
    return ibanNumber.test(sort);
  }

  static isAccountNumber(acc: string): boolean {
    return accountnumber.test(acc);
  }

  static isEmailAddress(email: string): boolean {
    return emailaddr.test(email);
  }

  static isNotEmpty(s: string): boolean {
    return s !== null && s.length > 0;
  }

  static isExpDate(date: ExpiryDate): boolean {
    return !!(date.month && date.year);
  }

  static isValidStartDate(dayInMonth: string, startDonation: ExpiryDate): boolean {
    if (dayInMonth !== undefined && dayInMonth !== '' && startDonation !== undefined && startDonation.year !== '' && startDonation.month !== '') {
    const startDate = new Date(Number('20' + startDonation.year),
                               Number(startDonation.month) - 1, (dayInMonth === '0') ? Number(Common.GetLastDayofMonth(startDonation.month)) : Number(dayInMonth));
    const todayDate = new Date();  
    if (startDate.getTime() > todayDate.getTime()) {
      return true;
    } else {return false; }
  } else {return true; }
  }

  static isValidStartDateMonthAndYear(day: string, month: string, year: string): boolean {
    const date = new Date();
    const currentDay = date.getDate();
    const currentMonth = date.getMonth();
    const currentYear = date.getFullYear();

    const currentDate = new Date(Number(currentYear), Number(currentMonth), Number(currentDay));
    const startDate = new Date(Number('20' + year), Number(month) - 1, Number(day));

    if (startDate <= currentDate) {
      return false;
    }

    return true;
  }

  static isValidatePostCodeRegex(pc: string, regex: RegExp): boolean {
    return regex.test(pc);
  }

  static isCardNumber(s: string): boolean {
    if (/[^0-9-\s]+/.test(s)) {
      return false;
    }

    // Luhn algorithm
    let nCheck: number = 0;
    let nDigit: number = 0;
    let bEven: boolean = false;

    s = s.replace(/\D/g, '');

    if (s.length < 12 || s.length > 19) {
      return false;
    }

    for (let n = s.length - 1; n >= 0; n--) {
      let cDigit = s.charAt(n);

      nDigit = parseInt(cDigit, 10);

      if (bEven) {
        if ((nDigit *= 2) > 9) {
          nDigit -= 9;
        }
      }

      nCheck += nDigit;
      bEven = !bEven;
    }

    return nCheck % 10 === 0;
  }

  static isMonth(s: string): boolean {
    let n = parseInt(s, 10);

    if (!n) {
      return false;
    }

    return n >= 1 && n <= 12;
  }

  static isYear(s: string): boolean {
    let n = parseInt(s, 10);

    if (!n) {
      return false;
    }

    return s.length <= 2;
  }

  static isIssueNumber(s: string): boolean {
    return issuenumber.test(s) || s.length === 0;
  }

  static isSecurityCode(s: string): boolean {
    return securitycode.test(s);
  }

  static isDomain(s: string): boolean {
    return domain.test(s);
  }
}

export default Validator;



// WEBPACK FOOTER //
// ./src/Helpers/validator.ts